import {
  LocationFragment,
  MaterialFragment,
  StockTypeFragment,
} from "../../models/autogenerated-deliveryService-gql/graphql";
import { INewOrderQueryData } from "../../models/newOrderQueryData";

export enum NewOrderQueryDataReducerActionTypes {
  SetMaterials = "SetMaterials",
  SetStockTypes = "SetStockTypes",
  SetLocations = "SetLocations",
  SetState = "SetState",
}

interface IQueryDataSetMaterials {
  type: NewOrderQueryDataReducerActionTypes.SetMaterials;
  value: MaterialFragment[];
}

interface IQueryDataSetStockTypes {
  type: NewOrderQueryDataReducerActionTypes.SetStockTypes;
  value: StockTypeFragment[];
}

interface IQueryDataSetLocations {
  type: NewOrderQueryDataReducerActionTypes.SetLocations;
  value: LocationFragment[];
}

interface IQueryDataSetState {
  type: NewOrderQueryDataReducerActionTypes.SetState;
  value: INewOrderQueryData;
}

export type IQueryDataAction =
  | IQueryDataSetMaterials
  | IQueryDataSetStockTypes
  | IQueryDataSetLocations
  | IQueryDataSetState;

export const newOrderQueryDataReducer = (
  state: INewOrderQueryData,
  action: IQueryDataAction,
) => {
  switch (action.type) {
    case NewOrderQueryDataReducerActionTypes.SetMaterials:
      return { ...state, materials: action.value };
    case NewOrderQueryDataReducerActionTypes.SetStockTypes:
      return { ...state, stockTypes: action.value };
    case NewOrderQueryDataReducerActionTypes.SetLocations:
      return { ...state, locations: action.value };
    case NewOrderQueryDataReducerActionTypes.SetState:
      return action.value;
    default:
      return state;
  }
};
